import PropTypes from 'prop-types';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { PATH_PAYMENTEZ } from "../routes/paths";

StepsGuard.propTypes = {
    children: PropTypes.node
};

const STATUS_FINISHED = 7;
const STATUS_CORRECTION_ONLY_ENABLING = 8;
const STATUS_CORRECTION_ONLY_ENABLING_BY_AFFILIATE = 9;

const Step1IsDisabled = (status) => {

    if (status === 1 || status > 3) {

        return false;
    }
    return true
}

const Step2IsDisabled = (status) => {

    if (status === 1 || status > 3) {

        return false;
    }
    return true;
}

const Step3IsDisabled = (status) => {

    if (status === 1 || status > 3) {

        return false;
    }
    return true;
}

const IsStepCompleted = (status) => status === 5 || status === 7;



export default function StepsGuard() {
    const { businessData } = useAuth();
    const params = useParams();
    const { pathname } = useLocation();


    const getAffiliationInfo = businessData?.affiliationData.find(e => e.affiliationDataId === params.affiliation && e.typeAffiliation === 1);

    if (getAffiliationInfo !== undefined) {
        const IsReferralMedianet = getAffiliationInfo?.isReferralMedianet;
        const ActiveBankDatafastInReferralMedianet = getAffiliationInfo?.activeBankDatafastInReferralMedianet;
        const statusAffiliation = getAffiliationInfo.statusAffiliate;

        const step1Status = getAffiliationInfo.stepStatus?.find(e => e.step === 1)?.status;
        const step2Status = getAffiliationInfo.stepStatus?.find(e => e.step === 2)?.status;
        const step3Status = getAffiliationInfo.stepStatus?.find(e => e.step === 3)?.status;

        const urlEstablishmentData = PATH_PAYMENTEZ.app.gateway.establishmentData + params.affiliation;
        const urlEnablingDocuments = PATH_PAYMENTEZ.app.gateway.enablingDocuments + params.affiliation;
        const urlPmzDocuments = PATH_PAYMENTEZ.app.gateway.paymentezDocuments + params.affiliation;
        const urlBanksDocuments = PATH_PAYMENTEZ.app.gateway.banksDocuments + params.affiliation;
        const urlPanel = PATH_PAYMENTEZ.app.gateway.monitoringPanel + params.affiliation;
        const urlStateDocument = PATH_PAYMENTEZ.app.gateway.monitoringStateDocument + params.affiliation;
        const urlResume = PATH_PAYMENTEZ.app.gateway.resume + params.affiliation;

        // Estado 8: puede acceder al panel y a documentos habilitantes
        if (statusAffiliation === STATUS_CORRECTION_ONLY_ENABLING) {
            const isInAllowedRoute = pathname === urlEnablingDocuments || pathname === urlPanel || pathname === urlStateDocument;
            if (!isInAllowedRoute) {
                return <Navigate to={urlEnablingDocuments} replace />;
            }
        }

        // Estado 9: Asesor verificando habilitantes corregidos (comercio puede ver panel, stateDocument y habilitantes)
        if (statusAffiliation === STATUS_CORRECTION_ONLY_ENABLING_BY_AFFILIATE) {
            const isInAllowedRoute =
                pathname === urlPanel ||
                pathname === urlStateDocument ||
                pathname === urlEnablingDocuments;
            if (!isInAllowedRoute) {
                return <Navigate to={urlPanel} replace />;
            }
        }

        if (pathname === urlEstablishmentData && statusAffiliation === STATUS_FINISHED) {
            return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
        }


        // Autoregistro público: sólo Datos del establecimiento y Documentación Nuvei (sin habilitantes ni bancos).
        // La Documentación Nuvei se habilita en cuanto se completan los Datos del establecimiento.
        const isPublicSelfRegistration = businessData?.isPublicSelfRegistration;

        if (isPublicSelfRegistration && pathname === urlEnablingDocuments) {
            return <Navigate to={urlPanel} replace />;
        }

        if (pathname === urlEnablingDocuments && Step1IsDisabled(step1Status) && statusAffiliation < STATUS_FINISHED) {
            return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
        }

        if (pathname === urlPmzDocuments && statusAffiliation < STATUS_FINISHED) {
            const pmzBlocked = isPublicSelfRegistration
                ? Step1IsDisabled(step1Status)
                : (Step1IsDisabled(step1Status) || Step2IsDisabled(step2Status));
            if (pmzBlocked) {
                return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
            }
        }

        if (pathname === urlBanksDocuments) {

            if (!IsReferralMedianet) {
                if (pathname === urlBanksDocuments && (Step1IsDisabled(step1Status) || Step2IsDisabled(step2Status) || Step3IsDisabled(step3Status)) && statusAffiliation < STATUS_FINISHED) {
                    return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
                }
            }

            if (IsReferralMedianet) {

                if (ActiveBankDatafastInReferralMedianet) {
                    if (pathname === urlBanksDocuments && (Step1IsDisabled(step1Status) || Step2IsDisabled(step2Status) || Step3IsDisabled(step3Status)) && statusAffiliation < STATUS_FINISHED) {
                        return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
                    }
                } else {
                    return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
                }
            }

        }



        if (pathname === urlPanel && statusAffiliation === STATUS_FINISHED) {
            return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
        }

        if (pathname === urlStateDocument && statusAffiliation === STATUS_FINISHED) {
            return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
        }

        if (pathname === urlResume && statusAffiliation < STATUS_FINISHED) {
            return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;
        }

    } else {

        return <Navigate to={PATH_PAYMENTEZ.app.pageAllAffiliations} />;

    }


    return <Outlet />;
}
